import { c as _c } from "react/compiler-runtime";
/**
 * SectionHeader Component
 *
 * Displays a section with an orange subheading and large navy title.
 * Used to introduce new sections on CMS pages.
 *
 * Renders `<h2>` by default. For the primary page title (pages without a
 * PageHero above it) pass `as="h1"` so the page has exactly one H1.
 *
 * @example
 * <SectionHeader
 *   subheading="Desktop Viewing"
 *   title="Key features of SCW Viewstation"
 * />
 */

import { cn } from '@/lib/utils';
interface SectionHeaderProps {
  /** Orange subheading text (e.g., "Desktop Viewing") */
  subheading?: string;
  /** Large navy title text */
  title: string;
  /** Additional CSS classes */
  className?: string;
  /** Center align text (default: false, left-aligned) */
  centered?: boolean;
  /** Heading level. Defaults to 'h2'. Pass 'h1' when this is the page's primary title. */
  as?: 'h1' | 'h2' | 'h3';
}
export function SectionHeader(t0) {
  const $ = _c(13);
  const {
    subheading,
    title,
    className,
    centered: t1,
    as: t2
  } = t0;
  const centered = t1 === undefined ? false : t1;
  const Heading = t2 === undefined ? "h2" : t2;
  const t3 = centered && "text-center";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cn("mb-12", t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== subheading) {
    t5 = subheading && <span className="block text-xl md:text-2xl font-medium mb-2" style={{
      color: "var(--scw-orange)"
    }}>{subheading}</span>;
    $[3] = subheading;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: "var(--scw-navy)"
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== Heading || $[7] !== title) {
    t7 = <Heading className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight" style={t6}>{title}</Heading>;
    $[6] = Heading;
    $[7] = title;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}